import React from 'react';
import InputField from './form/InputField';
import { required } from './form/validators';

const BusinessNameView = () => {
  return (
    <InputField
      name="name"
      label="Business Name"
      placeholder="The full name of your business"
      validate={required('Please enter your full business name.')}
    />
  );
};

export default BusinessNameView;
